export default __webpack_public_path__ + "static/media/謝宏昀.3ccd07a1.jpg";